import { Component } from '@angular/core';
import { TroubleShootEs2000Service } from '../service/trouble-shoot-es2000.service';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { LandingService } from '../../landing-page/service/landing.service';
import { SafePipe } from '../pipe/safe.pipe';
import { GenericService } from '../../generic.service';
import { language } from '../../../assets/data/languageData';
import { HeaderComponent } from '../../shared/header/header.component';
import { Subscription } from 'rxjs';
import { LanguageService } from '../../shared/service/language.service';
import { defaultLanguage } from '../../shared/constants/language.constants';
import { CrowdinService } from '../../shared/service/crowdin.service';

@Component({
    selector: 'app-steps-es2000',
    imports: [CommonModule, RouterModule, SafePipe, HeaderComponent],
    templateUrl: './steps-es2000.component.html',
    styleUrl: './steps-es2000.component.scss'
})
export class StepsEs2000Component {
  stepId: string | null = '';
  step: any;
  stepsList: any;
  currentStepIndex: number = 0;
  issueName: string | undefined;
  deviceData: any = {};
  deviceData$: any = null;
  popupDetails = {
    url: 'a',
    showPopup: false,
    isImage: true,
  };
  disMachineDetail: any;
  qrId: any;
  accountNumber: string = '';
  languageIndex: number = 0;
  translations: { [key: string]: string } = {};
  currentLanguage: string = defaultLanguage;
  languageOptions: Array<{ value: string }> = [];
  isLoadingTranslations = true;
  subs = new Subscription();

  constructor(
    private troubleShootService: TroubleShootEs2000Service,
    private route: ActivatedRoute,
    private router: Router,
    private genericService: GenericService,
    private landingService: LandingService,
    private crowdinService: CrowdinService,
  ) {
    this.deviceData$ = this.genericService.deviceData.subscribe((data) => {
      if (data) {
        this.deviceData = data;
      }
    });
  }

  ngOnInit() {
    this.languageOptions = this.landingService.getLanguageOptions();

    const stored = localStorage.getItem('deviceData');
    const selectedName = stored
      ? JSON.parse(stored).languageSelected || defaultLanguage
      : defaultLanguage;
    this.currentLanguage = selectedName;

    this.subs.add(
      this.landingService.languageName$.subscribe((langName) => {
        this.currentLanguage = langName;
        this.languageIndex =
          this.crowdinService.getLanguageIndexByName(langName);
        this.translations = this.crowdinService.getAllTranslations();
      }),
    );

    this.landingService.loadTranslations(this.currentLanguage);
    this.stepId = this.route.snapshot.paramMap.get('stepId');
    if (this.stepId) {
      this.step = this.troubleShootService.getTroubleShootStep(this.stepId);
      this.stepsList = this.troubleShootService.getStepState();
      this.issueName = this.troubleShootService.getIssuename();
      if (this.stepsList && this.stepsList.length) {
        this.currentStepIndex = this.troubleShootService.getStepIndex(
          this.stepId,
        );
      }
    }

    this.getDishmanchineDetails();
  }

  async languageChange(event: any) {
    const selectedLang = event.target.value;
    await this.landingService.loadTranslations(selectedLang);
  }

  getDishmanchineDetails(): void {
    let modelNumber = localStorage.getItem('modelNumber');
    if (modelNumber) {
      this.landingService.getDishMachineDetailsV2().subscribe((disMachine) => {
        this.disMachineDetail = disMachine;
        this.disMachineDetail = disMachine[modelNumber];
      });
    }
  }

  selection(option: any) {
    if (option?.steps[0]?.key) {
      let key = option?.steps[0]?.key;

      this.router.routeReuseStrategy.shouldReuseRoute = function () {
        return false;
      };
      this.router.onSameUrlNavigation = 'reload';

      const originalUrl: string = this.router.url;
      const parts: string[] = originalUrl.split('/'); // Split the URL by '/'
      const lastPart: string | undefined = parts.pop(); // Remove the last part and store it
      if (lastPart) {
        const replacedUrl: string = originalUrl.replace(lastPart, key); // Replace the last part with "abc"
        this.router.navigateByUrl(replacedUrl);
      }
    }
  }

  start(option: any) {
    option = this.stepsList[1];

    if (option?.key) {
      let key = option?.key;

      this.router.routeReuseStrategy.shouldReuseRoute = function () {
        return false;
      };
      this.router.onSameUrlNavigation = 'reload';

      const originalUrl: string = this.router.url;
      const parts: string[] = originalUrl.split('/'); // Split the URL by '/'
      const lastPart: string | undefined = parts.pop(); // Remove the last part and store it
      if (lastPart) {
        const replacedUrl: string = originalUrl.replace(lastPart, key); // Replace the last part with "abc"
        this.router.navigateByUrl(replacedUrl);
      }
    }
  }

  next(option: any) {
    this.deviceData['languageSelected'] = this.currentLanguage;
    this.genericService.setLocalStorage(this.deviceData);
    this.genericService.deviceData.next(this.deviceData);
    this.currentStepIndex = this.currentStepIndex + 1;

    option = this.stepsList[this.currentStepIndex];

    if (option?.key) {
      let key = option?.key;

      this.router.routeReuseStrategy.shouldReuseRoute = function () {
        return false;
      };
      this.router.onSameUrlNavigation = 'reload';

      const originalUrl: string = this.router.url;
      const parts: string[] = originalUrl.split('/'); // Split the URL by '/'
      const lastPart: string | undefined = parts.pop(); // Remove the last part and store it
      if (lastPart) {
        const replacedUrl: string = originalUrl.replace(lastPart, key); // Replace the last part with "abc"
        this.router.navigateByUrl(replacedUrl);
      }
    }
  }

  resolved() {
    this.router.navigateByUrl('thankYou');
  }

  openImage(imageUrl: string) {
    this.popupDetails.isImage = true;
    this.popupDetails.url = imageUrl;
    this.popupDetails.showPopup = true;
  }

  openVideo(videoUrl: string) {
    this.popupDetails.isImage = false;
    this.popupDetails.url = videoUrl;
    this.popupDetails.showPopup = true;
  }

  closePopup() {
    this.popupDetails.showPopup = false;
  }

  requestHelp(option: any) {
    const accountNumber = this.deviceData?.accountNumber || this.accountNumber;
    this.deviceData['issueName'] = this.issueName;
    this.deviceData['languageSelected'] = this.currentLanguage;
    this.genericService.setLocalStorage(this.deviceData);
    this.genericService.deviceData.next(this.deviceData);
    this.router.navigate([`/esrSupport/${accountNumber}`]);
  }
}
